import Canvas from './components/Canvas'

const DrawingApp = () => (
  <div className='h-screen w-full flex justify-center items-center'>
    <Canvas />
  </div>
)
export default DrawingApp
